import {FC, useState} from "react";

import {Container, BtnBack, SideBarInfoTabsItem} from "../styles";
import IconBtnBack from "../../assets/icons/icon-btn-back.svg";
import {MENU_TABS} from "./data";
import {TabInfoOne} from "./Tabs/TabInfoOne";
import {TabInfoTwo} from "./Tabs/TabInfoTwo";
import {TabInfoThree} from "./Tabs/TabInfoThree";

const menuTabs = MENU_TABS;

const SidebarInfoMapTehnology: FC = () => {
  const [activeTab, setActiveTab] = useState(1);
  const renderTabContent = (tab: number) => {
    switch (tab) {
      case 1:
        return <TabInfoOne />;
      case 2:
        return <TabInfoTwo />;
      case 3:
        return <TabInfoThree />;
      default:
        return <TabInfoOne />;
    }
  };
  return (
    <div style={{padding: "20px 50px"}}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          gap: 10,
        }}
      >
        {menuTabs.length > 0 &&
          menuTabs.map((item) => {
            return (
              <SideBarInfoTabsItem
                isActive={activeTab === item.id}
                key={item.id}
                onClick={() => setActiveTab(item.id)}
              >
                {item.title}
              </SideBarInfoTabsItem>
            );
          })}
      </div>
      <div style={{marginTop: "20px"}}>{renderTabContent(activeTab)}</div>
    </div>
  );
};

export default SidebarInfoMapTehnology;
